module.exports = __webpack_public_path__ + "static/media/crnm-front.75464477.jpg";